import React, { Component } from 'react'
import styled from 'styled-components'

const ContentContainer = styled.main`
clear: both
`

class Content extends Component {
  render() {
    return (
      <ContentContainer>
        {this.props.children}
      </ContentContainer>
    )
  }
}

export default Content
